import { useMemo } from 'react';
import get from 'lodash/get';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getManagerPermissions } from '../../../../store/settings/selectors';
import { getAuthenticateUser } from '../../../../store/authenticate/selectors';
import { usePermissions } from '../../../../hooks/useCommon';

export function useOrderPermissions() {
  const settings = useAppSelector(getManagerPermissions);
  const { personnel } = useAppSelector(getAuthenticateUser);
  const { permissions } = usePermissions();

  const ordersPermissions = useMemo(() => ({
    isAllowManage: (!permissions.isEmployee && get(settings, 'actions.orders.manage')) || permissions.isAdmin,
  }), [personnel.permissionLevel, settings]);

  return {
    ordersPermissions,
  };
}
